import { useState, ChangeEvent } from "react";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import CustomTabs from "../Collaborators/Tab/CustomTabs";
import CustomTab from '../Collaborators/Tab/CustomTabMain';
import PerformanceEvaluation from "./PerformanceEvaluation";
import ModelPerformanceEvaluation from "./ModelPerformanceEvaluation";
import CompetencePerformanceEvaluation from "./CompetencePerformanceEvaluation";
import HistoricalPerformanceEvaluation from "./HistoricalPerformanceEvaluation";
import CheckPermission from "../../helpers/Administradores/Permissions";


const PerformanceEvaluationContent = () => {
  const [tab, setTab] = useState(0);

  const handleChange = (event: ChangeEvent<{}>, newValue: number) => {
    setTab(newValue)
    localStorage.setItem('currentPill', String(newValue));
  };

  
  return (
    <div>
      <Box mt={3} ml={5} className="Title" mb={2}>
        Evaluaciones de desempeño
      </Box>
      <Box p={5} pb={3} pt={0}>
        <Grid
          container
          justify="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={12} md={8}>
            <CustomTabs
              value={tab}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
             {/* { CheckPermission("EvalDesempenio.Evaluaciones") && ( 
               <CustomTab label="Evaluaciones" value={0} />
              )} 

            {CheckPermission("EvalDesempenio.ModelosDeEvaluacion") && (
               <CustomTab label="Modelos de evaluación" value={1} />
              )}   
              
              <CustomTab label="Competencias" value={2} />
              <CustomTab label="Históricas" value={3} /> */}
              
              <CustomTab label="Competencias" value={0} />
             {CheckPermission("EvalDesempenio.ModelosDeEvaluacion") && (
               <CustomTab label="Modelos de evaluación" value={1} />
              )}  

             { CheckPermission("EvalDesempenio.Evaluaciones") && ( 
               <CustomTab label="Evaluaciones" value={2} />
              )}               
              <CustomTab label="Históricas" value={3} />
              
            </CustomTabs>
          </Grid>
          <Grid item xs={12} md={6}>
            {
              tab === 1 && (
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="flex-end"
                  style={{ width: "100%" }}
                >
                  
                {/* {CheckPermission("KPIs.Historicas.Crear") && (
                      <Box>
                      <BtnCreate />
                    </Box>
                )} */}
                </Box>
              )
            }
          </Grid>
        </Grid>

      </Box>
      <div className="contenedor2">
        {tab === 0 && <CompetencePerformanceEvaluation />}
        {tab === 1 && <ModelPerformanceEvaluation />}
        {tab === 2 && <PerformanceEvaluation />}
        {/*{tab === 3 && <HistoricalPerformanceEvaluation />} */}
        
      </div>
      {/* <CreateCampaigns /> */}
    </div>

  )

}

export default PerformanceEvaluationContent
